import SettingSystemAPI from '@/api/SettingSystemAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	/**
	 * Lấy thông tin thiết lập
	 */
	loadSettingSystem: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SettingSystemAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true,
			false
		);
		if (res && res.Data) {
			context.commit('updateSettingSystem', res.Data);
			return res.Data;
		}
		return null;
	},

	/**
	 * Cập nhật thông tin thiết lập
	 */
	updateSettingSystem: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SettingSystemAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/change-setting`,
				data: payload
			},
			true
		);
		if (res && res.Data && res.Success) {
			//Modified by NVHIEN on 23/09/2026 - Tách các field phục vụ ghi NKTC ra khỏi dữ liệu trước khi lưu vào store,
			//tránh store nhiễm AuditingLogActionType/ListTypeChange... và bị gửi kèm sang lần lưu thiết lập khác
			const {
				AuditingLogActionType,
				ChangeSettingAuditLog,
				ListTypeChange,
				IsInbot,
				AuditLogSettingTemplate,
				IsChangeAmountBeforeDiscountDeviationValue,
				...data
			} = payload;
			context.commit('updateSettingSystem', data);
			return res.Data;
		}
		return false;
	},

	/**
	 * Cập nhật thiết lập hóa đơn tự động tải của meinvoice
	 */
	updateDownloadMeInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SettingSystemAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/update-isdownloadmeinvoice`,
				data: payload
			},
			true
		);
		if (res && res.Data) {
			return res.Data;
		}
		return false;
	}
};
